import React, { useState, useEffect } from 'react'
import { Panel, Table } from 'rsuite'
import { cloneDeep } from 'lodash-es'
import PanalLoadingTemplate from '../loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ReactECharts from 'echarts-for-react'
import { CHART_THEME } from '../../constants/project'

export default function Chart10Issue() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [chartOption, setChartOption] = useState()

  useEffect(() => {
    handelGetSchema()
  }, [])

  const handelGetSchema = async () => {
    setIsLoading(true)
    try {
      // const response = await getUserProfile()
      const response = mockShema
      let chartOp = cloneDeep(chartSchema)

      chartOp.series.name = response.header
      chartOp.series[0].data = response.datas

      setChartOption(chartOp)
      setSchema(response)
    } catch (e) {
      setError({})
    }
    setIsLoading(false)
  }

  if (!schema || isLoading) {
    return <PanalLoadingTemplate />
  }

  return (
    <Panel
      header={schema.header || '10 ประเด็นสูงสุด'}
      bordered
      shaded
      collapsible
      defaultExpanded
      style={{ marginTop: 10, marginBottom: 10 }}
    >
      <ReactECharts
        theme={CHART_THEME}
        option={chartOption}
        style={{ minHeight: '400px', width: '100%' }}
        className={'react_for_echarts'}
      />
    </Panel>
  )
}
const mockShema = {
  header: '10 ประเด็นสูงสุด',
  datas: [
    { name: 'การคุ้มครองผู้บริโภค', value: 10 },
    { name: 'อุบัติเหตุ', value: 20 },
    { name: 'แอลกอฮอล์', value: 30 },
    { name: 'สุภาพจิต', value: 40 },
    { name: 'ยาสูบ', value: 15 },
    { name: 'สิ่งแวดล้อม', value: 25 },
    { name: 'อาหาร', value: 30 },
    { name: 'กิจกรรมทางกาย', value: 35 },
    { name: 'สุขภาวะชุมชน', value: 15 },
    { name: 'อื่นๆ', value: 5 },
  ],
}

const chartSchema = {
  title: {
    text: '',
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
  },
  toolbox: {
    show: true,
    bottom: '10',
    feature: {
      saveAsImage: { show: true, title: 'บันทึกเป็นรูป' },
    },
  },
  legend: { top: '-1%', left: 'center' },
  series: [
    {
      name: '',
      type: 'pie',
      radius: ['40%', '70%'],
      avoidLabelOverlap: false,
      itemStyle: {
        borderRadius: 10,
        borderColor: '#fff',
        borderWidth: 2,
      },
      label: {
        show: false,
        position: 'center',
      },
      emphasis: {
        label: {
          show: true,
          fontSize: 14,
          fontWeight: 'bold',
        },
      },
      labelLine: {
        show: false,
      },
      data: [],
    },
  ],
}
